import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c8de086"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { style: {"padding":"0 0.16rem 0.16rem 0.16rem","font-size":"0.28rem"} }
const _hoisted_5 = { style: {"color":"red"} }
const _hoisted_6 = { class: "box mark" }
const _hoisted_7 = { class: "high-light" }
const _hoisted_8 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_9 = {
  key: 1,
  style: {"text-align":"left","display":"inline-block","width":"50px"}
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","padding":"10px 10px 0 10px","font-size":"14px"} }, " ⚠️⚠️⚠️ 点击排行榜中某一片区名称，下方会联动展示该区域下对应的所有厅台毛利排行榜 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "片区毛利排行榜", -1))
const _hoisted_14 = {
  key: 1,
  class: "mark"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  class: "row",
  style: {
                    background: '#E5F6F4',
                    fontWeight: 600,
                    padding: '10px',
                    fontSize: '16px',
                    lineHeight: '20px',
                  }
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"color":"blue","font-weight":"400","font-size":"14px","padding-left":"5px"} }, "点击此处联动下方", -1))
const _hoisted_18 = { class: "grap" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_20 = { style: {"position":"relative"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "营业厅毛利排行榜", -1))
const _hoisted_23 = {
  key: 3,
  class: "mark"
}
const _hoisted_24 = {
  class: "row",
  style: {
                    background: '#E5F6F4',
                    fontWeight: 600,
                    padding: '10px',
                    fontSize: '14px',
                  }
}
const _hoisted_25 = { class: "grap" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_27 = { style: {"position":"relative"} }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","padding":"10px 10px 0 10px","font-size":"14px"} }, " ⚠️⚠️⚠️ 点击排行榜中某一分公司名称，下方会联动展示该分公司下对应的所有厅台毛利排行榜 ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "分公司毛利排行榜", -1))
const _hoisted_32 = {
  key: 1,
  class: "mark"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  class: "row",
  style: {
                    background: '#E5F6F4',
                    fontWeight: 600,
                    padding: '10px',
                    fontSize: '16px',
                    lineHeight: '20px',
                  }
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"color":"blue","font-weight":"400","font-size":"14px","padding-left":"5px"} }, "点击此处联动下方", -1))
const _hoisted_36 = { class: "grap" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_38 = { style: {"position":"relative"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "营业厅毛利排行榜", -1))
const _hoisted_42 = {
  key: 3,
  class: "mark"
}
const _hoisted_43 = {
  class: "row",
  style: {
                    background: '#E5F6F4',
                    fontWeight: 600,
                    padding: '10px',
                    fontSize: '14px',
                  }
}
const _hoisted_44 = { class: "grap" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_46 = { style: {"position":"relative"} }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "店员销售排行TOP30", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row mark",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", { style: {
                  width: '100px',
                  flexGrow: 0,
                } }, " 销售姓名 "),
  /*#__PURE__*/_createElementVNode("div", { style: {
                  width: '100px',
                  flexGrow: 2,
                } }, " 所属厅台 "),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "月累积毛利")
], -1))
const _hoisted_51 = { class: "mark" }
const _hoisted_52 = { style: {
                    width: '100px',
                    flexGrow: 0,
                  } }
const _hoisted_53 = { style: {
                    width: '100px',
                    flexGrow: 2,
                  } }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import {
  CellGroup,
  Cell,
  Tabs,
  Tab,
  Overlay,
  Loading,
  Empty,
  Icon,
} from "vant";
import { formatPercentage, numToMoney } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessHallBJlMonthlyMbdc',
  setup(__props) {

const route = useRoute();
const active = ref(0);
const productOrderPayCountAsc = ref(false); // 产品-下单成功量升序

const visible = ref(false);
const pageData = ref<any>({});
let time = dayjs(route?.params.time as string).format("YYYY-MM");
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/bh/target-achievement-monthly-summary",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
    console.log(pageData.value);
  } else {
    // showFailToast(res.data);
  }
};
getPageData();
// 片区
const SliceDimension = ref<any>([]);
const getSliceDimensionData = async () => {
  const res = await request({
    url: "/api/wx/bh/area-businessHall-target-monthly-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "manager",
      province: "北京",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    SliceDimension.value = res.data.map((item) => {
      return {
        ...item,
        mrelativeRatioFlag: item.mrelativeRatio.indexOf("-") !== -1,
      };
    });
    console.log(SliceDimension.value);
    if (res.data?.[0]?.areaBusinessHallName) {
      getmanagerBusinessHallList(res.data[0].areaBusinessHallName, 0);
    }
  } else {
    // showFailToast(res.data);
  }
};
getSliceDimensionData();
const managerBusinessHallList = ref<any[]>([]);
const managerActiveItem = ref(0);
const getmanagerBusinessHallList = async (manager: any, index: any) => {
  managerActiveItem.value = index;
  const res = await request({
    url: "/api/wx/bh/area-businessHall-target-monthly-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "businessHall",
      province: "北京",
      manager: manager,
      area: "",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    managerBusinessHallList.value = res.data.map((item) => {
      return {
        ...item,
        mrelativeRatioFlag: item.mrelativeRatio.indexOf("-") !== -1,
      };
    });
    // if (res.data?.[0]?.area) {
  }
};
// 区域排行
const areaList = ref<any>([]);
const getProductsData = async () => {
  const res = await request({
    url: "/api/wx/bh/area-businessHall-target-monthly-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "area",
      province: "北京",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    areaList.value = res.data.map((item) => {
      return {
        ...item,
        mrelativeRatioFlag: item.mrelativeRatio.indexOf("-") !== -1,
      };
    });
    if (res.data?.[0]?.areaBusinessHallName) {
      handleClick(res.data[0].areaBusinessHallName, 0);
    }
  } else {
    // showFailToast(res.data);
  }
};
getProductsData();

// 选择区域
const selectedArea = ref("");
const businessHallList = ref<any[]>([]);
const handleClick = async (areaBusinessHallName: any, index: number) => {
  const res = await request({
    url: "/api/wx/bh/area-businessHall-target-monthly-top",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      groupUnit: "businessHall",
      province: "北京",
      area: areaBusinessHallName,
      manager: "",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    businessHallList.value = res.data.map((item) => {
      return {
        ...item,
        mrelativeRatioFlag: item.mrelativeRatio.indexOf("-") !== -1,
      };
    });
  } else {
    // showFailToast(res.data);
  }
};
// handleClick();
// 店员排行
const distributorLoading = ref(false);
const sellerList = ref<any>([]);
const getSellerList = async () => {
  distributorLoading.value = true;
  const res = await request({
    url: "/api/wx/bh/hall-target-monthly-sale-person/detail",
    method: "GET",
    params: {
      startDay: time,
      endDay: time,
      // searchOption: {
      //   startDay: time,
      //   endDay: time,
      //   statisticColumn: "salesMan",
      //   orderItem: {
      //     field: "grossProfit",
      //     asc: false,
      //   },
      //   salePerson: true,
      //   province: "北京",
      //   // groupUnit: sessionStorage.getItem("openid"),
      // },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  distributorLoading.value = false;
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    sellerList.value = res.data;
  } else {
    // showFailToast(res.data);
  }
};
getSellerList();

watch(productOrderPayCountAsc, () => {
  getProductsData();
});

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
const activeItem = ref(0);
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Icon), {
          size: "0.28rem",
          name: "warning-o",
          color: "red"
        }),
        _createTextVNode(" 下方数据为"),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY年MM月")), 1),
        _createTextVNode("的北京营业厅收入月报 ")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(Cell), {
                title: item.name,
                size: 
              index === 0 || index === 2 || index === 3 ? 'large' : 'normal'
            ,
                class: _normalizeClass(index === 0 || index === 2 || index === 3 ? 'bold' : ''),
                "title-style": { width: '100px', flex: 'inherit' },
                border: index !== 3,
                key: index
              }, {
                value: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    (
                    item.name !== '当日终端总量' &&
                    item.name !== '新增号卡总量' &&
                    item.name !== '当日订单总量'
                  )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.type === "percentage"
                      ? _unref(formatPercentage)(item.value)
                      : _unref(numToMoney)(item.value)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.value), 1)),
                    (item.name == '当月累积毛利')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createTextVNode(" （月环比："),
                          _createElementVNode("span", {
                            style: _normalizeStyle({ color: item.percentage >= 0 ? 'green' : 'red' })
                          }, _toDisplayString(`${item.percentage >= 0 ? "+" : ""}${_unref(formatPercentage)(
                        item.percentage
                      )}`), 5),
                          _createTextVNode(" ） ")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["title", "size", "class", "border"]))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_11,
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { title: "片区维度" }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13,
                (!SliceDimension.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(SliceDimension.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (
                  getmanagerBusinessHallList(item.areaBusinessHallName, index)
                ),
                          style: { borderBottom: '1px solid #ebedf0' },
                          class: _normalizeClass({ active: managerActiveItem.value === index }),
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                      one: index == 0,
                      two: index == 1,
                      three: index == 2,
                      other: index > 2,
                    })
                            }, _toDisplayString(index + 1), 3),
                            _createTextVNode(" " + _toDisplayString(item.areaBusinessHallName) + " ", 1),
                            _hoisted_17
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", null, " 月目标毛利: " + _toDisplayString(_unref(numToMoney)(item.mtargetGrossMargin)), 1),
                            _hoisted_19,
                            _createElementVNode("div", _hoisted_20, [
                              _createTextVNode(" 月累积毛利: " + _toDisplayString(_unref(numToMoney)(item.maccumulateGrossMargin)) + " ", 1),
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.mrelativeRatioFlag,
                        positive: item.mrelativeRatioFlag,
                      })
                              }, " (月环比: " + _toDisplayString(item.mrelativeRatio) + ") ", 3)
                            ]),
                            _hoisted_21,
                            _createElementVNode("div", null, "月累积达成率: " + _toDisplayString(item.machievementRate), 1)
                          ])
                        ], 10, _hoisted_15))
                      }), 128))
                    ])),
                _hoisted_22,
                (!managerBusinessHallList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 2,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerBusinessHallList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: { borderBottom: '1px solid #ebedf0' },
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                      one: index == 0,
                      two: index == 1,
                      three: index == 2,
                      other: index > 2,
                    })
                            }, _toDisplayString(index + 1), 3),
                            _createTextVNode(" " + _toDisplayString(item.areaBusinessHallName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", null, " 月目标毛利: " + _toDisplayString(_unref(numToMoney)(item.mtargetGrossMargin)), 1),
                            _hoisted_26,
                            _createElementVNode("div", _hoisted_27, [
                              _createTextVNode(" 月累积毛利: " + _toDisplayString(_unref(numToMoney)(item.maccumulateGrossMargin)) + " ", 1),
                              _hoisted_28,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.mrelativeRatioFlag,
                        positive: item.mrelativeRatioFlag,
                      })
                              }, " (月环比: " + _toDisplayString(item.mrelativeRatio) + ") ", 3)
                            ]),
                            _hoisted_29,
                            _createElementVNode("div", null, "月累积达成率: " + _toDisplayString(item.machievementRate), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "分公司维度" }, {
              default: _withCtx(() => [
                _hoisted_30,
                _hoisted_31,
                (!areaList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (handleClick(item.areaBusinessHallName, index)),
                          style: { borderBottom: '1px solid #ebedf0' },
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                      one: index == 0,
                      two: index == 1,
                      three: index == 2,
                      other: index > 2,
                    })
                            }, _toDisplayString(index + 1), 3),
                            _createTextVNode(" " + _toDisplayString(item.areaBusinessHallName) + " ", 1),
                            _hoisted_35
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", null, " 月目标毛利: " + _toDisplayString(_unref(numToMoney)(item.mtargetGrossMargin)), 1),
                            _hoisted_37,
                            _createElementVNode("div", _hoisted_38, [
                              _createTextVNode(" 月累积毛利: " + _toDisplayString(_unref(numToMoney)(item.maccumulateGrossMargin)) + " ", 1),
                              _hoisted_39,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                        minus: !item.mrelativeRatioFlag,
                        positive: item.mrelativeRatioFlag,
                      })
                              }, " (月环比: " + _toDisplayString(item.mrelativeRatio) + ") ", 3)
                            ]),
                            _hoisted_40,
                            _createElementVNode("div", null, "月累积达成率: " + _toDisplayString(item.machievementRate), 1)
                          ])
                        ], 8, _hoisted_33))
                      }), 128))
                    ])),
                _hoisted_41,
                (!businessHallList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 2,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessHallList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: { borderBottom: '1px solid #ebedf0' },
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                      one: index == 0,
                      two: index == 1,
                      three: index == 2,
                      other: index > 2,
                    })
                            }, _toDisplayString(index + 1), 3),
                            _createTextVNode(" " + _toDisplayString(item.areaBusinessHallName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", null, " 月目标毛利: " + _toDisplayString(_unref(numToMoney)(item.mtargetGrossMargin)), 1),
                            _hoisted_45,
                            _createElementVNode("div", _hoisted_46, [
                              _createTextVNode(" 月累积毛利: " + _toDisplayString(_unref(numToMoney)(item.maccumulateGrossMargin)) + " ", 1),
                              _hoisted_47,
                              _createElementVNode("div", {
                                class: _normalizeClass({
                      minus: !item.mrelativeRatioFlag,
                      positive: item.mrelativeRatioFlag,
                    })
                              }, " (月环比: " + _toDisplayString(item.mrelativeRatio) + ") ", 3)
                            ]),
                            _hoisted_48,
                            _createElementVNode("div", null, "月累积达成率: " + _toDisplayString(item.machievementRate), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "店员维度" }, {
              default: _withCtx(() => [
                _hoisted_49,
                _hoisted_50,
                (!sellerList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sellerList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_52, _toDisplayString(item.employee), 1),
                      _createElementVNode("div", _hoisted_53, _toDisplayString(item.businessHallName), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.monthGrossProfit)), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})